import React from 'react';
import GoogLogo from '!!react-svg-loader!../sign-up-form/google-logo.svg';
import Button from '@mui/material/Button';
import { useGoogleLogin } from '@react-oauth/google';
import { Typography } from '@mui/material';
import { Trans } from '@lingui/macro';
import { httpClient } from '@cocoplatform/coco-rtc-client';
import ClassroomIcon from './google-classroom.png';

export default function ConnectGoogleClassroom(p: {
  onSuccess?: () => void;
  onError?: (err: any) => void;
  style?: React.CSSProperties;
  signUp?: boolean;
}) {
  const login = useGoogleLogin({
    onSuccess: async (res) => {
      const response = await httpClient.post('/user/google-classroom', {
        code: res.code,
      });

      if (response.status === 200) {
        if (p.onSuccess) p.onSuccess();
      } else {
        if (p.onError) p?.onError(response.data);
      }
    },
    onError: p.onError,
    scope:
      'https://www.googleapis.com/auth/classroom.courses.readonly https://www.googleapis.com/auth/classroom.rosters.readonly https://www.googleapis.com/auth/classroom.profile.emails',
    flow: 'auth-code',
  });
  return (
    <Button
      // variant='outlined'
      color='secondary'
      variant='contained'
      size='large'
      disableElevation
      onClick={() => {
        login();
      }}
      sx={{
        paddingY: '0.8rem',
      }}
      startIcon={
        <img
          src={ClassroomIcon}
          style={{ height: '1.5rem', marginRight: '0.5rem' }}
        />
      }
    >
      <Typography variant='h4'>
        <Trans>Connect Google Classroom</Trans>
      </Typography>
    </Button>
  );
}
